import React, { FC } from 'react';
import { Button } from 'antd';
import { Hamburger, Receipt } from 'common/svg';
import { priceFormatter } from 'common/helpers/format.helper';
import { EPurchaseOrderStatus, IPurchaseOrder } from 'entities/PurchaseOrder/PurchaseOrder.models';
import { PurchaseOrderStatusDot } from 'entities/PurchaseOrder/components/PurchaseOrderStatusDot';
import { getShortStoreName } from 'entities/Store/Store.helper';

interface IComponentProps {
  item: IPurchaseOrder;
  onView: () => void;
}

export const TrackPOKanbanCard: FC<IComponentProps> = ({ item, onView }) => {
  const storeName = getShortStoreName(item.storeCode, item.storeName);

  return (
    <div className="kanban-board__card">
      <div className="kanban-board__card-header">
        <div className="flex flex-align-center">
          <PurchaseOrderStatusDot status={item.status} />
          <span
            className="ml-3 ff-medium fs-xxs"
            style={{ textDecoration: item.status === EPurchaseOrderStatus.Canceled ? 'line-through' : '' }}
          >{`SO#:${item.sonum}`}</span>
        </div>
        <Button className="btn-secondary h-24" onClick={onView}>
          View
        </Button>
      </div>

      <div className="kanban-board__card-body">
        <div className="kanban-board__card-body-row">
          <div className="kanban-board__card-body-row-label">
            <Hamburger className="icon-gray" />
            Store
          </div>
          <span className="kanban-board__card-body-row-value">{storeName}</span>
        </div>
        <div className="kanban-board__card-body-row">
          <div className="kanban-board__card-body-row-label">
            <Receipt className="icon-gray" />
            Order Amnt
          </div>
          <span className="kanban-board__card-body-row-value">{priceFormatter(item.amount)}</span>
        </div>
      </div>
    </div>
  );
};
